export const DEFAULT_FRESH_MEAL_PLAN_PRICING_INFO_MAP_CONFIG = {
  includeTrialPlans: false,
};